




































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import moment from "moment";
import ItemAtendimento from "@/views/private/cadastros/saude/atendimento/ItemAtendimento.vue";
import DadosRemocao from "./DadosRemocao.vue";
import { saudeAtendimentoService } from "@/service/cadastro/saude/atendimento/SaudeAtendimentoService";
import DetalheAtendimentoModel from "@/models/cadastros/saude/DetalheAtendimentoModel";
import JsZip from 'jszip';

@Component({
  components: {
    ItemAtendimento,
    DadosRemocao,
  },
})
export default class DadosSolicitacao extends Vue {
  @Prop()
  detalhe!: DetalheAtendimentoModel;

  @Prop()
  mensagemPagamento!: string;

  loadingDownload = false;

  get possuiPrestador(): boolean {
    return !!this.detalhe.prestador?.cpfCnpj;
  }

  get isRemocao() {
    return (
      this.detalhe.tipoAtendimento?.toUpperCase() == "REMOCAO" ||
      this.detalhe.tipoAtendimento?.toUpperCase() == "REMOÇÃO"
    );
  }

  downloadRequerimentoMedico() {
    if (this.detalhe?.id && !!this.detalhe.pedidosMedicos?.length) {
      const pedidos = this.detalhe.pedidosMedicos;
      this.loadingDownload = true;
      const zip = new JsZip();

      (pedidos as unknown as {nomeArquivo: string}[]).forEach((pedido, i) => {
        saudeAtendimentoService
          .obterRequerimentoMedico(this.detalhe?.id || 0, pedido.nomeArquivo)
          .then((res: Blob) => {
            const type = res.type.split('/');
            zip.file(`requerimento_${i+1}.${type[type.length-1]}`, res);

            if (i == (pedidos.length - 1)) {
              zip.generateAsync({type:"blob"})
                .then((content: Blob) => {
                  const downloadUrl = window.URL.createObjectURL(content);
                  const link = document.createElement("a");
                  link.href = downloadUrl;
                  link.setAttribute("download", 'requerimentosMedico.zip');
                  document.body.appendChild(link);
                  link.click();
                  link.remove();
                  this.loadingDownload = false;
                });
            }
          })
          .catch((err) => {
            this.loadingDownload = false;
          });
      });
    }
  }

  isDownloadRequerimento() {
    return (
      !!this.detalhe?.pedidosMedicos && this.detalhe.pedidosMedicos.length > 0
    );
  }

  // TODO revisar a apresentação dos campos das solicitações de orçamento
  get isAtendimentoOrcado(): boolean {
    return (
      this.detalhe.tipoAtendimento === "CIRURGIA" ||
      this.detalhe.tipoAtendimento === "REMOCAO" ||
      this.detalhe.tipoAtendimento?.toUpperCase() === "REMOÇÃO"
    );
  }
}
